import React from 'react'
import Grid from '@material-ui/core/Grid'
import { IconButton } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import CalendarIcon from '@material-ui/icons/CalendarTodayOutlined'

import moment, { Moment } from 'config/moment'
import { STRINGS } from 'consts'

interface PrizeDateRangeFieldsProps {
  startDate: Moment | null
  expiration: Moment | null
  onStartDateChange: (date: Moment | null) => void
  onExpirationChange: (date: Moment | null) => void
  disabled?: boolean
  requiredStartDate?: boolean
  requiredExpiration?: boolean
  enforceStartNotBeforeToday?: boolean
}

const PrizeDateRangeFields: React.FC<PrizeDateRangeFieldsProps> = ({
  startDate,
  expiration,
  onStartDateChange,
  onExpirationChange,
  disabled,
  requiredStartDate,
  requiredExpiration,
  enforceStartNotBeforeToday = true,
}) => {
  const inputLabelProps = {
    style: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: 14,
    },
  }

  const inputProps = {
    style: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: 14,
      paddingLeft: 10,
    },
    endAdornment: (
      <IconButton>
        <CalendarIcon style={{ width: 15, height: 15, color: '#6B7280' }} />
      </IconButton>
    ),
  }

  const today = moment().startOf('day')

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <DatePicker
          value={startDate}
          onChange={onStartDateChange}
          autoOk
          format={STRINGS.DATE_FORMAT}
          disabled={disabled}
          style={{ width: '100%' }}
          label="Fecha de inicio"
          {...(enforceStartNotBeforeToday
            ? {
                minDate: today,
                minDateMessage: 'La fecha de inicio debe ser igual o mayor al día actual',
              }
            : {})}
          maxDate={expiration || undefined}
          maxDateMessage="La fecha de inicio no puede ser mayor que la fecha de vencimiento"
          InputLabelProps={inputLabelProps}
          InputProps={inputProps}
          required={requiredStartDate}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DatePicker
          value={expiration}
          onChange={onExpirationChange}
          autoOk
          format={STRINGS.DATE_FORMAT}
          disabled={disabled}
          style={{ width: '100%' }}
          label="Fecha de vencimiento"
          minDate={startDate || today}
          minDateMessage="La fecha de vencimiento debe ser mayor o igual a la fecha de inicio y al día actual"
          InputLabelProps={inputLabelProps}
          InputProps={inputProps}
          required={requiredExpiration}
        />
      </Grid>
    </Grid>
  )
}

PrizeDateRangeFields.defaultProps = {
  disabled: false,
  requiredStartDate: false,
  requiredExpiration: false,
  enforceStartNotBeforeToday: true,
}

export { PrizeDateRangeFields }
